/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Typography, Divider, Button, CircularProgress } from '@material-ui/core'
import { Add } from '@material-ui/icons'

import PreventScreen from './components/PreventScreen';

import Actions from '../../../../fluid/Actions/ActionFactory'
import { v4 as uuidv4 } from 'uuid';

const clone = require("rfdc")();

let prevent_temp = {
    type: "screen",
    name: null,
    route: null,
    config: "/src/configs/screens/screens/queue-config.js",
    roles: ["ROLE_L1", "ROLE_ADMIN"],
    show_in_sidebar : true,
    default_params : {
        ic_name : null,
        showAppbar : true,
        show_form_input : true,
        show_results : true,
        wv_fields : [],
        field_form : []
    },
    component : "prevent"
}

const blue_theme = createTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

class PreventScreens extends Component {
    state = {
        loading_ics : false,
        ic_objects : null,
        loading : false,
        prevent_screens : [],
        editing_id : null
    } 

    componentDidMount () {
        this.setState({...this.state, loading_ics : true}, () => {
            Actions("http_request", {
                url : "/sainapse/information_channel",
                method : 'get'
            }).then(res => {
                let ic_objects = res.data.result.filter(ic_obj => {return ic_obj.operations.includes("IRC")})
                this.setState({...this.state, ic_objects : ic_objects}, () => this.getPreventScreens())
            }).catch(err => {

            })
        })
    }

    getPreventScreens = () => {
        let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
        let op_section = routes.drawer.find(section => section.id === 'operations')
        let dqm_section = op_section.screens.find(section => section.id === 'dqm')
        let prevent_section = dqm_section.screens.find(section => section.id === 'prevent')
        let prevent_screens = prevent_section.screens.filter(screen => screen.component === 'prevent')
        this.setState({...this.state, prevent_screens: prevent_screens, loading_ics : false}, () => console.log("Prevent Screens : ", this.state.prevent_screens))
    }

    updatePreventScreens = (prevent_screens) => {
        console.log("Updating Search Screens with : ", prevent_screens)
        Actions('http_request', {
            url : "/sainapse/configuration/ui_routes",
            method : "get",
            data : {}
          }).then(res => {
            //let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
            let routes = res.data.result.config
            let op_section = routes.drawer.find(section => section.id === 'operations')
            let dqm_section = op_section.screens.find(section => section.id === 'dqm')
            let prevent_section = dqm_section.screens.find(section => section.id === 'prevent')
            prevent_section.screens = prevent_screens
            console.log("Adding Search Screens to Routes : ", dqm_section)
            console.log("Updating Routes : ", routes)
            
            Actions('http_request', {
                url : "/sainapse/configuration/ui_routes",
                method : "put",
                data : {
                    config : routes
                }
            }).then(res => {
                let routes = res.data.result.config
                let op_section = routes.drawer.find(section => section.id === 'operations')
                let dqm_section = op_section.screens.find(section => section.id === 'dqm')
                let prevent_section = dqm_section.screens.find(section => section.id === 'prevent')
                let prevent_screens = prevent_section.screens.filter(screen => screen.default_params !== null)
                this.setState({...this.state, prevent_screens: prevent_screens, editing_id : null}, () => sessionStorage.setItem('ui_routes', JSON.stringify(res.data.result.config)))
            })
          })
    }

    updatePrevent = (prevent_config) => {
        Actions('http_request', {
            url : "/sainapse/configuration/ui_routes",
            method : "get",
            data : {}
          }).then(res => {
            //let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
            let routes = res.data.result.config
            let op_section = routes.drawer.find(section => section.id === 'operations')
            let dqm_section = op_section.screens.find(section => section.id === 'dqm')
            let prevent_section = dqm_section.screens.find(section => section.id === 'prevent')
            let prevent_screens = prevent_section.screens.filter(screen => screen.default_params !== null)
            let prevent_index = prevent_screens.findIndex(prevent => prevent.id === prevent_config.id)
            if (prevent_index !== -1) {
                console.log("Updating Prevent Screen: ", prevent_config)
                prevent_screens.splice(prevent_index, 1, prevent_config)
            } else {
                console.log("Adding Prevent Screen: ", prevent_config)
                prevent_screens.push(prevent_config)
            }
            this.updatePreventScreens(prevent_screens)
          })    
    }

    renderPreventScreens = () => {
        if (this.state.loading_ics) {
            return (
                <div style = {{width : '100%', marginTop : '30px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                    <CircularProgress variant = 'indeterminate'/>
                </div>
            )
        } else {
            console.log('Prevent :: IC List : ', this.state.ic_objects)
            let prevent_screens = this.state.prevent_screens.map(prevent_screen => {
                return (
                    <PreventScreen
                        ic_list = {this.state.ic_objects}
                        config = {prevent_screen}
                        update = {(config) => this.updatePrevent(config)}
                        delete = {(config) => this.deletePrevent(config)}
                        enable_edit = {(config) => this.editPrevent(config)}
                        editing_id = {this.state.editing_id}
                    />
                )
            })

            return prevent_screens
        }
    }

    addScreen = () => {
        let new_prevent = clone(prevent_temp)
        new_prevent.id = uuidv4()
        let new_state = clone(this.state)
        new_state.prevent_screens.push(new_prevent)
        new_state.editing_id = new_prevent.id
        this.setState({...new_state})
    }

    deletePrevent = (config) => {
        let new_state = clone(this.state)
        let prevent_index = new_state.prevent_screens.findIndex(screen => screen.id === config.id)
        new_state.prevent_screens.splice(prevent_index, 1)
        this.updatePreventScreens(new_state.prevent_screens)
    }

    editPrevent = (config) => {
        this.setState({...this.state, editing_id : config.id})
    }

    renderAddScreen = () => {
        return (
            <Button
                style = {{marginTop : '10px'}}
                variant = 'contained'
                size = 'small'
                color = 'primary'
                startIcon = {<Add/>}
                onClick = {this.addScreen}
            >
                Add Screen
            </Button>
        )
    }

    renderContent = () => {
        if (this.state.loading_ics) {
            return (
                <div style = {{width : '100%', padding : '50px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress variant = 'indeterminate' color = 'primary'/>
                </div>
            )
        } else {
            return (
                <Fragment>
                    {this.renderPreventScreens()}
                    {this.renderAddScreen()}
                </Fragment>
            )
        }
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', maxHeight : '100%', overflow : 'auto', padding : '10px'}}>
                    <Typography variant = 'subtitle2'>Prevent Screens</Typography>
                    <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                    {this.renderContent()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(PreventScreens);